module.exports = __webpack_public_path__ + "assets/img/study_4.4deab57b.png";